import type { HiddenField } from '@/components/gateway-forms/types';

const UTM_FIELD_KEY = 'UTM_Parameter__c';

type RawHiddenField = {
  key?: string | null;
  name?: string | null;
  value?: unknown;
};

export function normalizeHiddenFields(
  items?: RawHiddenField[] | null,
): HiddenField[] {
  return (items ?? [])
    .map((item) => ({
      key: String(item?.key ?? item?.name ?? '').trim(),
      value: String(item?.value ?? ''),
    }))
    .filter((item) => item.key);
}

export function resolveCalculatorHiddenFields(
  utmParameter?: string | null,
  hiddenFields?: RawHiddenField[] | null,
): HiddenField[] | undefined {
  const normalized = normalizeHiddenFields(hiddenFields);
  const trimmedUtm = utmParameter?.trim() ?? '';

  if (!trimmedUtm) {
    return normalized.length ? normalized : undefined;
  }

  const hasUtmField = normalized.some((field) => field.key === UTM_FIELD_KEY);

  if (hasUtmField) {
    return normalized.length ? normalized : undefined;
  }

  return [{ key: UTM_FIELD_KEY, value: trimmedUtm }, ...normalized];
}
